import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Button } from '../button/button';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, Button],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private router = inject(Router);

  onBecomAPartnerClick(event: MouseEvent): void {
    if (this.router.url.includes('/partners')) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'instant' });
      window.dispatchEvent(new CustomEvent('marketplace:partners-reset'));
    }
  }

  openPreferences(event: MouseEvent): void {
    event.preventDefault();
    (window as Window & { OneTrust?: { ToggleInfoDisplay(): void } }).OneTrust?.ToggleInfoDisplay();
  }
}
